import styled from "styled-components";
import { FlexMixin } from "../../../../../../styles/common/mixins/helpers.styled.js";
export const Wrapper = styled.div.withConfig({
    displayName: "styled__Wrapper",
    componentId: "sc-fca54669-0"
})`
	${FlexMixin({
    direction: 'column'
})}
	@media (max-width: 1350px) {
		${FlexMixin({
    direction: 'row',
    justify: 'space-between'
})}
	}

	@media (max-width: 1100px) {
		${FlexMixin({
    direction: 'column'
})}
	}
`;
export const MapCoastsContainer = styled.div.withConfig({
    displayName: "styled__MapCoastsContainer",
    componentId: "sc-fca54669-1"
})`
	${FlexMixin({
    direction: 'column'
})}
	position: relative;
	margin: 0 auto;
	max-width: 1500px;
	width: 100%;
	padding: 0 20px;
`;
export const BackgroundImage = styled.div.withConfig({
    displayName: "styled__BackgroundImage",
    componentId: "sc-fca54669-2"
})`
	background-image: url(${({ $backgroundImage  })=>$backgroundImage});
	background-repeat: no-repeat;
	background-size: cover;
	background-position: 50%;
	position: relative;
	padding: 36px 0;

	::before {
		content: '';
		position: absolute;
		top: 0;
		width: 100%;
		height: 100%;
		background-color: ${({ theme  })=>theme.colors.white.base};
		opacity: 0.76;
	}
`;
export const InformationListImage = styled.div.withConfig({
    displayName: "styled__InformationListImage",
    componentId: "sc-fca54669-3"
})`
	background-image: url(${({ imageUrl  })=>imageUrl});
	background-position: center center;
	background-repeat: no-repeat;
	background-size: cover;
	height: 100px;
`;

//# sourceMappingURL=styled.js.map